export default {
  path: '*',
  redirect: '/',
};
